import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'


import '@/assets/styles.scss'
import { createPinia } from 'pinia'


import { createI18n } from 'vue-i18n'
import pl from '@/locales/pl.json'
import en from '@/locales/en.json'
import { useAuthorizationStore } from '@/components/authorization/model/AuthorizationRepository.ts'

export const i18n = createI18n({
  legacy: false,
  locale: 'pl',
  messages: {
    pl, en
  }
})

const pinia = createPinia()
const app = createApp(App)

const PaintShopPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    }
  }
})


app.use(PrimeVue, {
  theme: {
    preset: PaintShopPreset,
    options: {
      darkModeSelector: '.app-dark'
    }
  }
})
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(ToastService)
app.use(ConfirmationService)
app.directive('tooltip', Tooltip)
i18n.global.locale.value = useAuthorizationStore().getUserLocale as 'pl' | 'en'


app.mount('#app')

